import { LanguageStrings } from './base-strings';

export const jp: LanguageStrings = {
  /** Routes */
  'routes.appInit': '/',
  'routes.review': '/booking-review',
  'routes.registration': '/registration',
  'routes.confirm': '/confirm',
  'routes.checkinpayment': '/checkinpayment',
  'routes.confirmpayment': '/confirmpayment',
  'routes.hdfForm': '/hdf-form',
  'routes.search': '/search',
  'routes.selectDocumentType': '/select-document-type',
  'routes.takeDocumentPhoto': '/take-document-photo',
  'routes.addGuest': '/add-guest',

  /** Function Name */
  'review.menu.name': 'レビュー',
  'hdfForm.menu.name': '健康申告',
  'registration.menu.name': '登録',
  'confirm.menu.name': '確認',
  'error.menu.name': 'エラー',
  'search.menu.name': '検索',

  /** Page content */
  'home.title': 'ホーム',
  'home.content': '私のウェブページへようこそ',

  'summary.title': '概要',
  'summary.content': '詳細は以下のリンク {medium} と {devto} をご覧ください。',

  'loading.title': '読み込み中...',
  'loading.content': '予約の詳細情報を読み込んでいます。少々お待ちください。',
  'error.title': 'エラー',
  'error.content': 'エラーが発生しました。再度お試しください。',
  'error.required': '必須項目を入力してください',
  'error.dateOfBirth.day': '無効な日付です',
  'error.message2':
    'システムエラーが発生しました。詳細についてはシステム管理者にお問い合わせください。',
  'error.message.aleadySubmit':
    '必要な情報はすでに登録されています。ありがとうございます！',
  'error.message.notFound': '情報が見つかりません！',
  'error.message.urlInvalid': 'リンクが無効です！',
  'error.message.needReclickUrl':
    '「リンクが無効です。再度クリックしてください」と表示されます。',
  'error.message.flightNumber': 'フライト番号は例：CX231',
  'error.message.flightArrivalTime': '有効な時間を入力してください',
  'error.message.preference': 'ご希望を選択してください',

  /** Links */
  'links.medium':
    'https://medium.com/prototyped/multi-language-routing-in-react-d7eb7a0688e9',
  'links.dev.to': 'https://dev.to/prototyp/multi-language-routing-in-react-k9l',

  /** Payment T&C */
  'payment.t&c':
    '私はこの請求書に対する責任を免除しないことに同意し、これらの費用を個人的に全額負担することに同意します。',

  'payment.noPaymentMethod': '利用可能な支払い方法がありません',

  /** Choice Befor Pay Room Rate */
  'choice.roomrateTitleOptional':
    'ホテル到着時のチェックイン時間を短縮するために、今すぐ部屋代を支払いますか？',
  'choice.roomrateTitleCompulsory':
    'より迅速なチェックイン体験のために、事前に部屋代をお支払いください。ありがとうございます！',
  'choice.roomrate.no': 'いいえ、ホテル到着時に部屋代を支払います。',
  'choice.roomrate.title': '部屋代の明細',

  /** Choice */
  'choice.depositTitleOptional':
    'ホテル到着時のチェックイン時間を短縮するために、今すぐデポジットを支払いますか？',
  'choice.depositTitleCompulsory':
    'チェックインを早めるために、今すぐデポジットをお支払いください。',
  'choice.yes': 'はい',
  'choice.no': 'いいえ、ホテル到着時にデポジットを支払います。',
  'choice.deposit.title': 'デポジットの明細',
  'choice.deposit': 'デポジット',
  'choice.roomrate': '部屋代',
  'choice.total': '合計',
  'choice.warning': '続行するには、上記の条件に同意する必要があります。',
  'choice.askSaveCreditCard':
    '私は、ホテルがクレジットカードから商品およびサービスに関連する費用を差し引くことを許可します。私は、商業者が今後の支払いのために個人情報を保存する可能性があることに同意します。この条件は、要求に応じていつでも撤回できることを理解しています。',

  /** CheckInPayment */
  'checkinpayment.title': '部屋代を支払ってください',
  'checkinpayment.ok': 'OK',
  'checkinpayment.selectpaymentmethod': '支払い方法を選択してください',
  'checkinpayment.useSavedCard': '保存されたクレジットカードで支払う',
  'checkinpayment.success': '支払い成功',
  'checkinpayment.merchantRef': '取引番号：',
  'checkinpayment.mini.success': '予約の支払いが成功しました。',
  'checkinpayment.mini.success2':
    'お客様をお迎えできることを楽しみにしており、スムーズで思い出に残る滞在を提供することに努めます。',
  'checkinpayment.mini.success3': 'またお会いしましょう！',
  'checkinpayment.error': '取引に失敗しました。再度お支払いください',
  'checkinpayment.bankError':
    '取引が拒否されました。銀行にお問い合わせください',
  'checkinpayment.invoice': '請求書をメールでお送りします',
  'checkinpayment.continue': '続行',
  'checkinpayment.pleasescanqrcode': 'アプリでQRコードをスキャンしてください',
  'checkinpayment.payInNewTab': '新しいタブで支払いを完了してください',
  'checkinpayment.payInNewTabNotOpened':
    '新しいタブが自動的に開かない場合は、以下のボタンをクリックしてください',
  'checkinpayment.startPayment': '支払いを開始',

  /** Review */
  'review.title': '予約の詳細を確認し、「確認」ボタンをクリックしてください',
  'review.confirm.no': '予約番号',
  'review.guest.name': 'お名前',
  'review.checkin.date': 'チェックイン/チェックアウト日',
  'review.reserved.room.type': '部屋タイプ',
  'review.total.room.rate': '部屋代の合計',
  'review.preferences': '優先',
  'review.note':
    '予約の名前が身分証明書/パスポートと一致することを確認してください。ご質問がある場合は、resvn@royalplaza.com.hkまでメールしてください。',
  'review.video.note':
    '事前登録を行う前に、{play}ボタンをクリックして{video}を視聴してください。',
  'review.video.play': '再生',
  'review.video.video': 'ビデオ',
  'review.room.type.RSK': 'スーペリアルーム',
  'review.room.type.RST': 'スーペリアルーム',
  'review.room.type.RDK': 'デラックスルーム',
  'review.room.type.RDT': 'デラックスルーム',
  'review.room.type.RDH': 'デラックスルーム',
  'review.room.type.RPK': 'エグゼクティブルーム',
  'review.room.type.RPT': 'エグゼクティブルーム',
  'review.room.type.RPH': 'エグゼクティブルーム',
  'review.room.type.CDK': 'エグゼクティブデラックスルーム',
  'review.room.type.CDT': 'エグゼクティブデラックスルーム',
  'review.room.type.CDH': 'エグゼクティブデラックスルーム',
  'review.room.type.CPK': 'エグゼクティブエグゼクティブルーム',
  'review.room.type.CPT': 'エグゼクティブエグゼクティブルーム',
  'review.room.type.CPH': 'エグゼクティブエグゼクティブルーム',
  'review.room.type.STK': 'スイート',
  'review.room.type.STH': 'スイート',
  'review.room.type.SJK': 'スーペリアスイート',
  'review.room.type.SJT': 'スーペリアスイート',
  'review.room.type.SJH': 'スーペリアスイート',
  'review.room.type.SDK': 'デラックススイート',
  'review.room.type.SDH': 'デラックススイート',
  'review.room.type.SRK': 'ロイヤルスイート',
  'review.room.type.SPK': 'プレジデンシャルスイート',
  'review.room.type.TDK': 'スカイデラックスルーム',
  'review.room.type.TDH': 'スカイデラックスルーム',
  'review.room.type.THK': 'スカイオーシャンビュー',
  'review.room.type.THQ': 'スカイオーシャンビュー',
  'review.room.type.TSK': 'スカイ部分オーシャンビュー',
  'review.room.type.TSQ': 'スカイ部分オーシャンビュー',
  'review.room.type.HJH': 'スカイスーペリアスイート',
  'review.room.type.HVS': 'スカイオーシャンビュー',
  'review.room.type.DBD': 'スーペリアルーム',
  'review.room.type.TWD': 'スーペリアルーム',
  'review.room.type.QEA': 'デラックスルーム',
  'review.room.type.TWA': 'デラックスルーム',
  'review.room.type.QEE': 'エグゼクティブデラックスルーム',
  'review.room.type.TWE': 'エグゼクティブデラックスルーム',
  'review.room.type.KHC': 'ファミリールーム',
  'review.room.type.KHA': 'エグゼクティブファミリールーム',
  'review.room.type.QEC': 'エグゼクティブプラチナルーム',
  'review.room.type.TWC': 'エグゼクティブプラチナルーム',
  'review.room.type.QEAEF': 'デラックスエグゼクティブルーム',
  'review.room.type.KGAEF': 'エグゼクティブエグゼクティブルーム',
  'review.room.type.SKC': 'パーニングスイート',
  'review.room.type.SUP': 'スーペリアダブルルーム',
  'review.room.type.AWM': 'Anti-window (4 Ft)',
  'review.room.type.TD': 'タワーダブル',
  'review.room.type.DLX': 'デラックスルーム',
  //DWC
  'review.room.type.SUD': 'スーペリアルーム',
  'review.room.type.SUH': 'スーペリアルーム',
  'review.room.type.SUK': 'スーペリアルーム',
  'review.room.type.SUT': 'スーペリアルーム',
  'review.room.type.GCUD': 'スーペリアルーム（眺望付き）',
  'review.room.type.GCUK': 'スーペリアルーム（眺望付き）',
  'review.room.type.GCUT': 'スーペリアルーム（眺望付き）',
  'review.room.type.PDEQ': 'エグゼクティブコーズ湾都市ビュー',
  'review.room.type.PDED': 'エグゼクティブコーズ湾都市ビュー',
  'review.room.type.PDEK': 'エグゼクティブコーズ湾都市ビュー',
  'review.room.type.PDET': 'エグゼクティブコーズ湾都市ビュー',
  'review.room.type.PDCK': 'エグゼクティブパーマーヒルズドリンクビュー',
  'review.room.type.PDCQ': 'エグゼクティブパーマーヒルズドリンクビュー',
  'review.room.type.PDCT': 'エグゼクティブパーマーヒルズドリンクビュー',
  'review.room.type.PDCD': 'エグゼクティブパーマーヒルズドリンクビュー',
  'review.room.type.DTR': 'デラックススリーピングルーム',
  'review.room.type.DFQ': 'デラックスファミリー4人部屋',
  'review.room.type.EFQ': 'デラックスファミリー4人部屋',
  'review.room.type.ESK': 'エグゼクティブスイート',
  'review.room.type.EST': 'エグゼクティブスイート',

  /** Confirm */
  'confirm.title': '事前登録が完了しました',
  'confirm.reminder':
    'ホテル到着時にセルフチェックイン機をご利用いただけます。',
  'confirm.reminder.6641bd847063233124b3d922':
    '以下のQRコードを使用して東隅に到着することができます。',
  'confirm.reminder2': 'チェックイン時にチェックインQRコードをご提示ください。',
  'confirm.reminder2.6641bd847063233124b3d922': '',
  'confirm.thankyou': 'ありがとうございます。',
  'confirm.qrcode.err': 'QRコードの値が正しくありません',
  'confirm.notice.title': '特別なお知らせ:',
  'confirm.notice.covid19.title': '新型コロナウイルスに対する予防措置',
  'confirm.notice.covid19.detail': '詳細についてはご確認ください',
  'confirm.notice.covid19.link':
    'https://www.royalplaza.com.hk/hk/precautionary-measures-for-novel-coronavirus/',
  'confirm.notice.policy.title': 'プライバシーポリシーと免責事項',
  'confirm.notice.policy.detail': '詳細についてはご確認ください',
  'confirm.notice.policy.link':
    'https://www.royalplaza.com.hk/hk/disclaimer-privacy-statement/',
  'confirm.deposit':
    'チェックイン手続きをスムーズにするため、宿泊費を全額前払いしたお客様はデポジットを支払う必要はありません。追加費用は直接お支払いください。',

  /** Registration Page content */
  'reg.title': '事前登録',
  'reg.reminder':
    '以下に個人情報を入力し、「確認」ボタンをクリックしてください',
  'reg.wechat.reminder': '以下のQRコードをスキャンしてください。',
  'reg.firstName': '名',
  'reg.familyName': '姓',
  'reg.lastName': '姓',
  'reg.email': 'メール',
  'reg.email.noPersonal': 'メール',
  'reg.address1': '住所 1:',
  'reg.address': '住所',
  'reg.address2': '住所 2',
  'reg.pleaseSelect': '選択してください',
  'reg.country': '国',
  'reg.country.noRegion': '国',
  'reg.state': '都道府県',
  'reg.nationality': '国籍',
  'reg.zipCode': '郵便番号',
  'reg.postalCode': '郵便番号',
  'reg.arrivalHrs': '到着予定時刻',
  'reg.flightArrival.time': 'フライト到着時間 / 予定到着時間',
  'reg.arrival.hr': '時',
  'reg.arrival.min': '分',
  'reg.arrival.subject': '供給状況に応じて',
  'reg.tel': '携帯電話',
  'reg.passportNumber': 'パスポート番号',
  'reg.dateOfBirth': '生年月日',
  'reg.flightNumber': 'フライト番号',
  'reg.flightArrivalTime': '到着時間',
  'reg.evoucher':
    'ホテルのオファーとプロモーション情報を受け取る（電子メール、SMS、ソーシャルメディアを通じて）',
  'reg.evoucher.yes/no': '受け取る/受け取らない',
  'reg.evoucher.yes': '受け取る',
  'reg.evoucher.no': '受け取らない',
  'reg.method.inst.msg': 'インスタントメッセージ方法',
  'reg.method.inst.msg.select': 'メッセージ式を選択',
  'reg.method.inst.msg.sms': 'SMS',
  'reg.method.inst.msg.email': 'メール',
  'reg.method.inst.msg.whatsapp': 'Whatsapp',
  'reg.method.inst.msg.wechat': 'WeChat',

  'hdf.ask': '健康申告書を記入しますか？',
  'hdf.title': '健康申告書',
  'hdf.highRiskWarning.title': '内容を確認',
  'hdf.highRiskWarning.message': '再確認するか、ホテルにお問い合わせください。',
  'hdf.sign.title': '記載した情報がすべて正確であることを宣言します。',
  'hdf.sign.text': '以下に署名してください：',
  'hdf.sign.clear': 'クリア',

  'hdf.btn.fill': '記入',
  'hdf.btn.addGuest': '同伴者を追加',
  'hdf.btn.signAndConfirm': '署名して確認',
  'hdf.btn.submitForm': '確認',
  'hdf.btn.back': '戻る',
  'hdf.btn.backToReview': '登録に戻る',

  'hdf.guestName': '顧客名',
  'hdf.accompanyName': '同行者',
  'hdf.familyName': '姓',
  'hdf.firstName': '名',
  'hdf.dateOfBirth': '生年月日',
  'hdf.sex': '性別',
  'hdf.sex.m': '男',
  'hdf.sex.f': '女',
  'hdf.passport': 'パスポート/ID番号',
  'hdf.nationality': '国籍',
  'hdf.comeFrom': '旅行先',
  'hdf.arrivalDate': '到着日',
  'hdf.placesVisitedInSevenDays':
    '過去7日間に訪れた国や都市を列挙してください。',
  'hdf.contactWithCovid': '過去7日間にCOVID-19陽性者と接触しましたか？',
  'hdf.contactWithCovid.yes': 'はい',
  'hdf.contactWithCovid.no': 'いいえ',
  'hdf.symptom': '以下の症状はありますか？',
  'hdf.symptom.no': 'いいえ',
  'hdf.symptom.fever': '発熱',
  'hdf.symptom.breathingDifficulty': '呼吸困難',
  'hdf.symptom.cough': '咳',
  'hdf.symptom.diarrhoea': '下痢',
  'hdf.symptom.headache': '頭痛',
  'hdf.symptom.musclePain': '筋肉痛',
  'hdf.symptom.runnyNose': '鼻水',
  'hdf.symptom.soreThroat': '喉の痛み',
  'hdf.symptom.stuffyNose': '鼻詰まり',
  'hdf.symptom.vomiting': '嘔吐',
  'hdf.contact': '今後7日間の連絡先',
  'hdf.contact.phone': '電話番号',
  'hdf.email': 'メール',
  'hdf.address': '連絡先住所',
  'btn.confirm': '確認',
  'btn.hdf.form': '健康申告書',
  'btn.reset': 'リセット',
  'btn.cancel': 'キャンセル',
  'btn.identityCard': 'IDカード',
  'btn.passport': 'パスポート',
  'btn.take': '撮影',
  'btn.upload': 'アップロード',
  'btn.capture': 'キャプチャ',
  'btn.retake': '再撮影',
  'btn.reUpload': '再アップロード',
  'btn.retry': '再試行',
  'btn.register': '登録',
  'btn.remove': '削除',
  'btn.addGuest': '同伴者を追加',

  /** Document */
  'selectDocumentType.title': 'パスポートまたはIDカードを選択してください',
  'takeDocumentPhoto.title': '証明書の写真を提出する（正面）',
  'takeDocumentPhoto.noteTitle': '撮影のヒント',
  'takeDocumentPhoto.note1': '1. 環境は暗くないこと',
  'takeDocumentPhoto.note2':
    '2. 文字や/または画像が見えること、および切り取られていないこと',
  'takeDocumentPhoto.note3': '3. 画像が鮮明であること',
  'takeDocumentPhoto.takePhotoInstruction1':
    '画像を調整し、すべての情報がフレーム内に収まるようにしてください。',
  'takeDocumentPhoto.takePhotoInstruction2':
    'IDカードをフレーム内に置いてください。',
  'takeDocumentPhoto.takePhotoInstruction3':
    '携帯電話を縦向きに持ちます（縦向きモード）',
  'takeDocumentPhoto.uploadSuccess': 'アップロード成功',
  'takeDocumentPhoto.uploadFail': 'アップロード失敗',
  'takeDocumentPhoto.uploading': 'アップロード中...しばらくお待ちください',

  /** Add Guest */
  'accompanyGuest.title': '同伴者',
  'accompanyGuest.label.guestName': 'お名前',
  'accompanyGuest.label.lastName': '姓',
  'accompanyGuest.label.firstName': '名',
  'accompanyGuest.guestStatus.completed': 'ご登録済み',
  'accompanyGuest.guestStatus.inProgress': '未登録',
  'accompanyGuest.removeGuest.confirmation':
    'このゲストを削除してもよろしいですか？',

  /** Modal */
  'modal.title.removeGuest': 'ゲストを削除',
};
